import axios from 'axios';
import store from './../index'
import signalr from './../../config/signalr'

export default {
    state: {
        hubConnection: null,
        contentUpdate: false
    },
    getters: {
        HUB_CONNECTION: state => {
            return state.hubConnection
        },
        CONTENT_UPDATE: state => {
            return state.contentUpdate
        },
    },
    mutations: {
        SET_CONTENT_UPDATE: (state, payload) => {
            state.contentUpdate = payload;
        },
        SET_HUB_CONNECTION: (state, payload) => {

            // Старое соединение остаётся в store после выхода из аккаунта (store живёт до F5). У HubConnection
            // из @aspnet/signalr есть только stop(); вызов несуществующего disconnect() бросал TypeError прямо
            // из мутации, dispatch("CONNECT_HUB") падал синхронно и обрывал Global.created() до загрузки рекламы —
            // из-за этого список товаров на «Потребности» после повторного логина не рендерился до перезагрузки.
            if (state.hubConnection){
                try {
                    // флаг для onclose в CONNECT_HUB: остановленное приложением соединение не должно само переподключаться
                    state.hubConnection.stoppedByApp = true;
                    state.hubConnection.stop().catch(() => {});
                } catch (error) {
                    window.console.error('Failed to stop previous hub connection', error);
                }
            }
            let url = `${axios.defaults.baseURL}` + "/" + payload

            state.hubConnection = new signalr.HubConnectionBuilder()
                .withUrl(url, {
                    accessTokenFactory: () => store.getters.ACCESS_TOKEN
                }).configureLogging(signalr.LogLevel.Information)
                .build();

        },
    },
    actions: {
        CONNECT_HUB: () => {

            store.commit('SET_HUB_CONNECTION', "chat-hub");

            // замыкаемся на конкретный объект соединения: после повторного логина в store будет уже новое,
            // а onclose старого не должен ни переподключать его, ни трогать новое
            const connection = store.getters.HUB_CONNECTION

            let startedPromise = null

            function start() {
                if (connection.stoppedByApp) return Promise.resolve()
                startedPromise = connection.start().catch(err => {
                    window.console.error('Failed to connect with hub', err)
                    return new Promise((resolve, reject) =>
                        setTimeout(() => start().then(resolve).catch(reject), 6000))
                })

                return startedPromise
            }

            connection.onclose(() => start())

            start()

        }
    }
}